import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../withStyles';
import styles from './Icon.styles';
import paths from './paths';
export const Icon = ({ icon, title, className, classes, }) => {
    if (!paths[icon]) {
        console.warn(`Unsupported icon '${icon}' used in <Icon />`); // tslint:disable-line no-console
        return null;
    }
    const { path, viewBox } = paths[icon];
    return (_jsxs("svg", Object.assign({ viewBox: viewBox, className: cn(classes.icon, className) }, { children: [_jsx("path", { d: path }), title && _jsx("title", { children: title })] })));
};
export default withStyles(styles)(Icon);
//# sourceMappingURL=Icon.js.map